import { FC } from "react"
import { SidePanelAction } from "../../../../types"
import PrimaryBtn from "../primary-btn"
import Button from "../button"
import BtnDanger from "../btn-danger"

const ActionButton: FC<SidePanelAction> = ({ type, label, icon, ...rest }) => {
  if (type === "primary") {
    return (
      <PrimaryBtn key={label} {...rest}>
        {icon ? <span className="mr-1">{icon}</span> : null}
        {label}
      </PrimaryBtn>
    )
  }

  if (type === "danger") {
    return (
      <BtnDanger key={label} {...rest}>
        {icon ? <span className="mr-1">{icon}</span> : null}
        {label}
      </BtnDanger>
    )
  }

  return (
    <Button key={label} {...rest}>
      {icon ? <span className="mr-1">{icon}</span> : null}
      {label}
    </Button>
  )
}

export default ActionButton
